// Initial state for the app store. `params` shape lives in paramDefaults.ts
// (single source of truth for everything the pane reads). `selection` is the
// reactive slice the tooltip + region panel subscribe to.

import { buildInitialParams } from './paramDefaults';
import type { State } from './schema';

export const initialState: State = {
  params: buildInitialParams(),

  // Reactive slice for tooltip + region panel subscribers.
  // `sample` is the most-recent probe result; `pos` is its physical location.
  selection: {
    pos: null,
    sample: null,
    visible: true,
  },
};
